import React, {useState} from 'react';

import BusinessCalculator from "./incomeCalcParts/BusinessCalculator";
import DefaultCalculator from "./incomeCalcParts/DefaultCalculator";
import LastStepOfBusinessCalculator from "./incomeCalcParts/LastStepOfBusinessCalculator";
import {assetsBaseUrl} from "../../services/calculationsApi";
import {FormattedMessage} from "react-intl";

const IncomeCalculatorModal = ({toggleIncomeCalculator, field}) => {
    const [defaultCalculator, setDefaultCalculator] = useState(true);
    const [lastStepOpened, setLastStepOpened] = useState(false);

    const toggleLastStep = () => {
        setLastStepOpened(!lastStepOpened);
    };

    return (
        <div className="ct-step__modal-wrapper">
            <div className="ct-step__income-calculator-modal-wrapper">
                {!lastStepOpened ? (
                    <div>
                        <div className="ct-step__overview-modal-title">
                          <FormattedMessage id="incomeCalculator.general.title" defaultMessage="Jaarinkomen berekenen"/>
                        </div>

                        <div
                            className="close-income"
                            onClick={toggleIncomeCalculator}
                        >
                            <img
                                src={`${assetsBaseUrl}/assets/svg/close.svg`}
                                alt=""
                                className={"svg"}
                            />
                        </div>

                        <div>
                            <div className="ct-step__income-calculator-modal__subtitle">
                              <FormattedMessage id="incomeCalculator.general.subTitle" defaultMessage="Ik ben"/>
                            </div>

                            <div className="ct-step-xl-labels__container">
                                <button
                                    className={
                                        defaultCalculator
                                            ? "selected-xl-label"
                                            : null
                                    }
                                    onClick={() => setDefaultCalculator(true)}
                                >
                                  <FormattedMessage id="incomeCalculator.type.employed.title" defaultMessage="In loondienst"/>
                                </button>

                                <button
                                    className={
                                        !defaultCalculator
                                            ? "selected-xl-label"
                                            : null
                                    }
                                    onClick={() => setDefaultCalculator(false)}
                                >
                                  <FormattedMessage id="incomeCalculator.type.selfEmployed.title" defaultMessage="Ondernemer/ZZP'er"/>
                                </button>
                            </div>
                        </div>

                        {defaultCalculator ? (
                            <DefaultCalculator
                                toggleIncomeCalculator={toggleIncomeCalculator}
                                field={field}
                            />
                        ) : (
                            <BusinessCalculator
                                toggleIncomeCalculator={toggleIncomeCalculator}
                                field={field}
                                toggleLastStep={toggleLastStep}
                            />
                        )}
                    </div>
                ) : (
                    <LastStepOfBusinessCalculator
                        toggleIncomeCalculator={toggleIncomeCalculator}
                        field={field}
                        toggleLastStep={toggleLastStep}
                    />
                )}
            </div>
        </div>
    );
};

export default IncomeCalculatorModal;
